import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'

import './css/style.css';
import NavBar from "./NavBar"
import Footer from "./Footer"
import BackToTop from "./BackToTop"
import MovieDisplay from "./movieDisplay";
import TvDisplay from "./tvDisplay";
import PeopleDisplay from "./peopleDisplay";
import SearchMovies from "./searchMovies";
import SearchTV from "./searchTV";
import SearchPeople from "./searchPeople";
import MyList from "./MyList";

class Main extends React.Component {
    state = {
        loading: true
      };    
      componentDidMount() {
        // this simulates an async action, after which the component will render the content
        demoAsyncCall().then(() => this.setState({ loading: false }));
      }    
  render() {
    const { loading } = this.state;
    
    if(loading) { // if your component doesn't have to wait for an async action, remove this block 
      return null; // render null when app is not ready
    }      
    return (
        <Router> 
        <div className="container">
          <NavBar/>
            <div>
                <Switch>
                    <Route path = "/show/:query/:showId" component={TvDisplay} />
                    <Route path = "/movie/:query/:movieId" component={MovieDisplay} />
                    <Route path = "/people/:query" component={PeopleDisplay} />
                    <Route path="/movies" component={SearchMovies} />
                    <Route path="/shows" component={SearchTV} />
                    <Route path="/people" component={SearchPeople} />
                    <Route path="/my-list" component={MyList} />
                </Switch>           
            </div>
            <Footer />
            <BackToTop />
        </div>
        </Router>
    );
  }
}
function demoAsyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
  }
ReactDOM.render(<Main />, document.getElementById('root'));
